// Theme: 'light' (default) or 'dark'. Persisted to localStorage.
import { useCallback, useEffect, useState } from "react";

const KEY = "pmv5_theme";

function readInitial() {
  try {
    const v = localStorage.getItem(KEY);
    if (v === "light" || v === "dark") return v;
  } catch (_) {}
  return "light";
}

// Apply to <html data-theme="..."> as early as possible (also done in index.js).
function apply(theme) {
  if (typeof document === "undefined") return;
  document.documentElement.setAttribute("data-theme", theme);
}

export function useTheme() {
  const [theme, setTheme] = useState(readInitial);

  useEffect(() => {
    apply(theme);
    try { localStorage.setItem(KEY, theme); } catch (_) {}
  }, [theme]);

  const toggle = useCallback(() => setTheme(t => (t === "dark" ? "light" : "dark")), []);
  return { theme, setTheme, toggle };
}
